import { useEffect } from 'react';

import urls from '../utils/urls';

const useDialog = () => {

  const [ dialog, setDialog ] = urls.useParam('dialog');

  useEffect(() => {
    if (dialog) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [dialog]);

  return {
    dialog,
    setDialog,
  };
};

const utils = {
  useDialog,
};

export default utils;